export default __webpack_public_path__ + "img/pega-seo-legacy-modernazation-carousel.235890ee.png";